import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
import "../../Style/Header/Header.css";
import BackDrop from "../SideMenu/BackDrop";
import SideMenu from "../SideMenu/SideMenu";
import highMountainsLogo from "../../images/Highmountainsblack.png";
import axios from "axios";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallSharpIcon from "@mui/icons-material/CallSharp";
import MenuIcon from "@mui/icons-material/Menu";
import IMAGES from "../../images/LandingPage";
import { Link, useNavigate, useLocation } from "react-router-dom";
import AuthModal from "../AuthModal/AuthModal";
import { useAuth } from "../../context/AuthContext";
import { FaUserCircle } from "react-icons/fa"; // Add at top
import MyJourneyModal from "../AuthModal/MyJourneysModal"; // adjust path if needed
import { FaRegUser } from "react-icons/fa";

const Header = () => {
const { user, logout } = useAuth();

  const navigate = useNavigate();
  const [navbar, setNavbar] = useState(false);
  const [sideMenu, setSidemenu] = useState(false);
  const [domain, setDomain] = useState(false);
  const [allCategory, setAllCategory] = useState(false);
  const [trip, setTrip] = useState(null);
  const [search, setSearch] = useState(null);
  const [headerMenu, setHeaderMenu] = useState(null);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showJourneyModal, setShowJourneyModal] = useState(false);

// Detect Mobile Screen
const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 768);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

const location = useLocation();

const isLandingPageHeader = [
  "/landing-page-nye-trips",
  "/landing-page-domestic-trips",
  "/landing-page-international-trips",
  "/landing-page-nye-domestic-trips",
  "/landing-page-nye-international-trips",
    "/newyear-trips"

].includes(location.pathname);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  const searchTrip = trip?.filter((obj) =>
    obj.heading.toLowerCase().includes(search?.toLowerCase())
  );

  const getSelectedHomeCategory = () => {
  axios
    .get(`api/homecategory/get-home-category`)
    .then((res) => {
      console.log("✅ HomeCategory API Response:", res.data); // <-- ADD THIS LINE
      setHeaderMenu(res.data.data[0]?.headerMenu);
    })
    .catch((err) => {
      console.error("❌ HomeCategory API failed:", err); // <-- ADD THIS TOO
    });
};

  const NavbarBgChange = () => {
    if (window.scrollY >= 60) {
      setNavbar(true);
      setDomain(true);
    } else {
      setNavbar(false);
      setDomain(false);
    }
  };
  window.addEventListener("scroll", NavbarBgChange);

  const toggleMenu = () => {
    setSidemenu(!sideMenu);
  };

  const getAllTrips = async () => {
    const res = await axios.get("api/trips/get-all-trips");
    if (res.data.success) {
      setTrip(res.data.data);
    }
  };

  useEffect(() => {
    getAllTrips();
    getSelectedHomeCategory();
  }, []);

  return (
<>
    {isLandingPageHeader && window.innerWidth <= 768 ? (
      // ✅ LANDING PAGE HEADER (custom clean header)
      <div className="landing-header">
        {/* Left: Logo */}
        <div className="landing-left" onClick={() => navigate("/")}>
          <img
            src={highMountainsLogo}
            alt="High Mountains"
            className="landing-logo"
          />
        </div>

        {/* Center: NYE Trips */}
        <div className="landing-center">
          <Link to="/nye-trips" className="nye-badge">
            NYE Trips <span className="live-dot">LIVE NOW</span>
          </Link>
        </div>

        {/* Right: Call / WhatsApp */}
        {/* Right: Call / WhatsApp */}
<div className="landing-right">
  <Link to="tel:919888823721" className="landing-call-btn" aria-label="Call">
    <CallSharpIcon className="landing-call-icon" />
  </Link>
  <Link
    to="https://wa.me/919888823721"
    target="_blank"
    className="landing-wa-btn"
    aria-label="WhatsApp"
  >
    <WhatsAppIcon className="landing-wa-icon" />
  </Link>
</div>

      </div>
    ) : (<div className="header-main header-nav">
        <BackDrop sideMenu={sideMenu} closeSideMenu={toggleMenu} />
        <SideMenu sideMenu={sideMenu} setSidemenu={setSidemenu} />
        <nav className={`navbar active fixed-top`}>
          <div className="logo d-flex align-items-center">
            <div className="hmlogo">
              <img
                onClick={() => navigate("/")}
                width="70px"
                src={highMountainsLogo}
                alt=""
              />
            </div>
          </div>
<div className="nye-trips">
  <Link to="/nye-trips" className="offer-badge">
    NYE Trips <span className="live-dot">LIVE NOW</span>
  </Link>
</div>

          <div className="menu_list d-none d-lg-block">
  <ul className="d-flex align-items-center">

    {/* Existing dynamic menu */}
    {headerMenu &&
      headerMenu?.map((item, index) => (
        <li key={index}>
          <Link to={`/category/${item}`}>{item}</Link>
        </li>
      ))}
{/* <li>
  <Link to="/all-destinations">Destinations</Link>
</li> */}

    {/* --- New DESTINATIONS DROPDOWN START --- */}
    <li className="dropdown">
<Link to="/all-destinations" className="dropdown-title">
    Destinations ▾
  </Link>
      <ul className="dropdown-menu">
        <li className="dropdown-submenu">
          <span>Domestic Trips ▸</span>
          <ul className="dropdown-submenu-list">
              <li><Link to={`/category/Andaman%20and%20Nicobar`}>Andaman & Nicobar</Link></li>
                           <li><Link to={`/category/Goa`}>Goa</Link></li>
        <li><Link to={`/category/Himachal%20Pradesh`}>Himachal Pradesh</Link></li>
                  <li><Link to={`/category/Kargil`}>Kargil</Link></li>
                                             <li><Link to={`/category/Karnataka`}>Karnataka</Link></li>
 <li><Link to={`/category/Kashmir`}>Kashmir</Link></li>
                                    <li><Link to={`/category/Kerala`}>Kerala</Link></li>
                 <li><Link to={`/category/Lahaul`}>Lahaul</Link></li>
                               <li><Link to={`/category/Lakshadweep`}>Lakshadweep</Link></li>
        <li><Link to={`/category/Leh%20Ladakh`}>Leh Ladakh</Link></li>
                 <li><Link to={`/category/Meghalaya`}>Meghalaya</Link></li>
         <li><Link to={`/category/Rajasthan`}>Rajasthan</Link></li>
                     <li><Link to={`/category/Sikkim`}>Sikkim</Link></li>
 <li><Link to={`/category/Spiti%20Valley`}>Spiti Valley</Link></li>
        <li><Link to={`/category/Uttarakhand`}>Uttarakhand</Link></li>

          </ul>
        </li>

        <li className="dropdown-submenu">
          <span>International Trips ▸</span>
          <ul className="dropdown-submenu-list">
                                    <li><Link to={`/category/Azerbaijan`}>Azerbaijan</Link></li>

              <li><Link to={`/category/Bali`}>Bali</Link></li>
                                         <li><Link to={`/category/Bhutan`}>Bhutan</Link></li>

                      <li><Link to={`/category/Dubai`}>Dubai</Link></li>
                        <li><Link to={`/category/Georgia`}>Georgia</Link></li>
            <li><Link to={`/category/Ibiza`}>Ibiza</Link></li>
                <li><Link to={`/category/Iceland`}>Iceland</Link></li>
                        <li><Link to={`/category/Kazakhstan`}>Kazakhstan</Link></li>
                   <li><Link to={`/category/Kenya`}>Kenya</Link></li>
        <li><Link to={`/category/Maldives`}>Maldives</Link></li>
                <li><Link to={`/category/Nepal`}>Nepal</Link></li>
                                        <li><Link to={`/category/Oman`}>Oman</Link></li>
                        <li><Link to={`/category/Philippines	
`}>Philippines	
</Link></li>

                        <li><Link to={`/category/Sri%20Lanka`}>Sri Lanka</Link></li>
                        <li><Link to={`/category/Tanzania`}>Tanzania</Link></li>
 <li><Link to={`/category/Thailand`}>Thailand</Link></li>
                         <li><Link to={`/category/Turkey`}>Turkey</Link></li>

        <li><Link to={`/category/Vietnam`}>Vietnam</Link></li>

          </ul>
        </li>
        {/* <li>
  <Link to="/customise-trip">Customise Your Trip</Link>
</li> */}
{/* <li className="dropdown-submenu">
  <span>Customise Your Trip ▸</span>
  <ul className="dropdown-submenu-list">
    <li><Link to="/customise-trip">Start Customising</Link></li>
  </ul>
</li> */}

<li className="dropdown-submenu">
  <span onClick={() => navigate("/customise-trip")} style={{ cursor: "pointer" }}>
    Customise Your Trip
  </span>
</li>

      </ul>
    </li>
    {/* --- New DESTINATIONS DROPDOWN END --- */}

{/* --- New TRAVEL THEMES DROPDOWN START --- */}
<li className="dropdown travel-themes-dropdown">
  <span className="dropdown-title">Travel Themes ▾</span>
  <ul className="dropdown-menu travel-themes-menu">

    <li><Link to={`/category/Adventure`}>Adventure</Link></li>
                       <li><Link to={`/category/ASG Special's`}>ASG Special's</Link></li>
    <li><Link to={`/category/Autumn`}>Autumn</Link></li>
        <li><Link to={`/category/Backpacking Trips`}>Backpacking Trips</Link></li>
<li><Link to={`/category/Bike Trips`}>Bike Trips</Link></li>
           <li><Link to={`/category/Bachelors and Party`}>Bachelors and Party</Link></li>
         <li><Link to={`/category/Beaches and Islands`}>Beaches and Islands</Link></li>
        {/* <li><Link to={`/category/Community Trips`}>Community Trips</Link></li> */}
    {/* <li><Link to={`/category/Customised Trips`}>Customised Trips</Link></li> */}
       <li><Link to={`/category/Festival Diaries`}>Festival Diaries</Link></li>
       <li><Link to={`/category/Igloo Stay`}>Igloo Stay</Link></li>
           {/* <li><Link to={`/category/International Trips`}>International Trips</Link></li> */}

  
    <li><Link to={`/category/NYE`}>NYE</Link></li>
           {/* <li><Link to={`/category/NYE Community Trip`}>NYE Community Trip</Link></li> */}
{/* <li><Link to={`/category/NYE India Trips	
`}>NYE India Trips	
</Link></li> */}
           {/* <li><Link to={`/category/NYE International Trips`}>NYE International Trips</Link></li> */}
  
    <li><Link to={`/category/Road Trips`}>Road Trips</Link></li>
                       <li><Link to={`/category/Romantic Getaways`}>Romantic Getaways</Link></li>

             <li><Link to={`/category/Land Packages`}>Land Packages</Link></li>

             <li><Link to={`/category/Safari Specials`}>Safari Specials</Link></li>
                 <li><Link to={`/category/Summer Trips`}>Summer Trips</Link></li>

             
                     <li><Link to={`/category/Winter Trips`}>Winter Trips</Link></li>

                      {/* <li><Link to={`/category/Weekend Getaways`}>Weekend Getaways</Link></li> */}
                          <li><Link to={`/category/Wellness Escapes`}>Wellness Escapes</Link></li>

  </ul>
</li>
{/* --- New TRAVEL THEMES DROPDOWN END --- */}

  </ul>
</div>

{/* ✅ Hide Login/Signup completely on mobile for now */}
{!isLandingPageHeader && (
  <div className="auth-header-btn" style={{ position: "relative" }}>

    {/* ---------- MOBILE VIEW ---------- */}
    {isMobile ? (
      user ? (
        /* LOGGED IN → SHOW PROFILE ICON */
        <FaRegUser
          size={28}
          onClick={() => navigate("/account")}
          style={{ cursor: "pointer" }}
        />
      ) : (
        /* LOGGED OUT → SHOW USER-CIRCLE ICON */
        <FaUserCircle
          size={32}
          onClick={() => setShowAuthModal(true)}
          style={{ cursor: "pointer" }}
        />
      )
    ) : (
      
      /* ---------- DESKTOP VIEW ---------- */
      user ? (
        <div className="user-dropdown">
          <span className="user-name">
            Hi, {user.fullName?.split(" ")[0]} ▾
          </span>

          <ul className="user-dropdown-menu">
            <li onClick={() => navigate("/account")}>My Profile</li>
            {/* <li onClick={() => setShowJourneyModal(true)}>My Journey</li> */}
            <li onClick={logout}>Logout</li>
          </ul>
        </div>
      ) : (
        <span
          onClick={() => setShowAuthModal(true)}
          style={{ cursor: "pointer", fontWeight: 600 }}
        >
          Login / Signup
        </span>
      )
    )}
  </div>
)}




          {/* Contact Buttons */}
          <div className="contact-buttons">
           <Link
  className="wa-icon whatsapp-btn hide-on-mobile"
  target="_blank"
  to="https://wa.me/919888823721"
  aria-label="WhatsApp"
>
  <WhatsAppIcon className="icon" />
</Link>

            <Link
              className="wa-icon call-btn"
              to="tel:919888823721"
              aria-label="Call"
            >
              <CallSharpIcon className="icon" />
              <div className="call-text">
                <small>Call Us</small>
                <strong>+91 9888823721</strong>
              </div>
            </Link>
          </div>

          {/* SIDE MENU  */}
          <div className="nav_toggle_button d-lg-none" onClick={toggleMenu}>
            <MenuIcon />
          </div>
        </nav>
      </div>
   )}
      {/* Inline CSS */}
      <style>{`.nye-trips {
  margin-left: -21px;
  padding: 8px 10px;
  background: #e7f9f3;
  border: 1px solid #000000;
  border-radius: 16px;
  font-weight: 600;
  color: #000000;
  font-size: 12px;
  height: 32px;
  display: flex;
  align-items: center;
  line-height: 1;
  white-space: nowrap;
}

.offer-badge {
  display: flex;
  align-items: center;
  gap: 6px;
}

.live-dot {
  background-color: red;
  color: white;
  font-weight: bold;
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 10px;
  animation: pulse 1s infinite;
}
@keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

        .contact-buttons {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-left: 20px;
          white-space: nowrap;
        }

        .contact-buttons .wa-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          text-decoration: none;
          color: inherit;
          font-weight: 500;
          white-space: nowrap;
        }

        .whatsapp-btn {
          background: #f9f9f9;
          border-radius: 50%;
          width: 45px;
          height: 45px;
          box-shadow: 0 2px 5px rgba(0,0,0,0.1);
          transition: background-color 0.3s ease;
          flex-shrink: 0;
        }

        .whatsapp-btn:hover {
          background-color: #ffca00;
        }

        .whatsapp-btn .icon {
          color: #25d366;
          font-size: 28px;
        }

        .call-btn {
          background: #f9f9f9;
          padding: 0 15px;
          border-radius: 30px;
          height: 45px;
          display: flex;
          align-items: center;
          box-shadow: 0 2px 5px rgba(0,0,0,0.1);
          gap: 10px;
          transition: background-color 0.3s ease;
          color: black;
          white-space: nowrap;
          flex-shrink: 0;
        }

        .call-btn:hover {
          background-color: #4caf50;
          color: white;
        }

        .call-btn .icon {
          font-size: 28px;
          flex-shrink: 0;
        }

        .call-text {
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: 1;
        }

        .call-text small {
          font-weight: 400;
          font-size: 12px;
          margin: 0;
        }

        .call-text strong {
          font-weight: 700;
          font-size: 14px;
          margin: 0;
        }
.nye-trips {
  margin-left: -8px; /* pull NYE Trips closer to logo */
  margin-right: 5px; /* reduce space before menu */
  padding: 5px 8px;
  background: #e7f9f3;
  border: 1px solid #000;
  border-radius: 16px;
  font-weight: 600;
  color: #000;
  font-size: 12px;
  height: 28px;
  display: flex;
  align-items: center;
  line-height: 1;
  white-space: nowrap;
}
@media screen and (min-width: 1440px) {
  .nye-trips {
    margin-left: -196px !important; /* pulls NYE Trips closer to logo */
    margin-right: -45px !important; /* pulls NYE Trips closer to menu */
  }

  .menu_list {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  .navbar {
    gap: 0 !important; /* ensure no flex gap is adding space */
  }
}

        /* Responsive tweaks */
        @media (max-width: 991px) {
          .contact-buttons {
            margin-left: 10px;
            gap: 10px;
          }
          .call-text small {
            font-size: 10px;
          }
          .call-text strong {
            font-size: 12px;
          }
          /* Optional: you can hide text on smaller devices */
          /* .call-text {
            display: none;
          } */
        }@media (max-width: 991px) {
  .nye-trips {
    position: absolute;
    top: 70px; /* adjust if overlaps */
    left: 25%;
    transform: translateX(-50%);
    background: #e7f9f3;
    padding: 6px 10px;
    border: 1px solid #000;
    border-radius: 16px;
    font-size: 11px;
    font-weight: 600;
    z-index: 1000;
  }

  .nye-trips .offer-badge {
    gap: 5px;
  }

  .nye-trips .live-dot {
    font-size: 9px;
    padding: 1px 5px;
  }
}
/* Fix navbar layout between 992px and 1439px */
@media screen and (min-width: 992px) and (max-width: 1439px) {
  .navbar {
    flex-wrap: nowrap !important;
    gap: 4px !important;
  }

  .logo img {
    width: 36px !important; /* slightly smaller logo */
  }

  .nye-trips {
    margin-left: -150px !important;
    margin-right: 0 !important;
    padding: 4px 6px !important;
    font-size: 11px !important;
  }

  .menu_list ul {
    gap: 10px !important; /* tighten space between links */
  }

  .contact-buttons {
    gap: 6px !important;
    margin-left: 5px !important;
  }

  .call-btn {
    padding: 0 10px !important;
    height: 40px !important;
  }

  .whatsapp-btn {
    width: 40px !important;
    height: 40px !important;
  }

  .call-text strong {
    font-size: 12px !important;
  }

  .call-text small {
    font-size: 10px !important;
  }
}
/* Hide WhatsApp icon only on mobile */
@media (max-width: 768px) {
  .hide-on-mobile {
    display: none !important;
  }
}
.landing-header {
        width: 100%;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 16px;
        box-shadow: 0 2px 5px rgba(0,0,0,0.1);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
      } .landing-left .landing-logo {
        width: 60px;
        cursor: pointer;
      }

      .landing-center {
        text-align: center;
      }

      .nye-badge {
        background: #e8f6f3;
        border: 1px solid #000;
        padding: 4px 10px;
        border-radius: 20px;
        font-weight: 600;
        font-size: 13px;
        text-decoration: none;
        color: #000;
      }@keyframes pulse {
        0% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.6; transform: scale(1.1); }
        100% { opacity: 1; transform: scale(1); }
      }

      .landing-right {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .landing-call-btn,
      .landing-wa-btn {
        width: 36px;
        height: 36px;
        background: #f9f9f9;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 1px 4px rgba(0,0,0,0.1);
      }

      .landing-call-btn .icon {
        color: #333;
        font-size: 20px;
      }

      .landing-wa-icon {
  color: #25d366 !important;
  font-size: 20px;
}

      @media (max-width: 768px) {
        .landing-logo {
          width: 60px;
        }
        .nye-badge {
          font-size: 11px;
          padding: 3px 8px;
        }
        .landing-call-btn,
        .landing-wa-btn {
          width: 32px;
          height: 32px;
        }
      }
        .user-dropdown {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.user-name {
  font-weight: 500;
}

.user-dropdown-menu {
  position: absolute;
  top: 26px;
  right: 0;
  background: white;
  list-style: none;
  padding: 8px 0;
  margin: 0;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  display: none;
  z-index: 9999;
  width: 120px;
}

.user-dropdown:hover .user-dropdown-menu {
  display: block;
}

.user-dropdown-menu li {
  padding: 10px 14px;
  cursor: pointer;
  font-size: 14px;
}

.user-dropdown-menu li:hover {
  background: #f5f5f5;
}
.mobile-user-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: black;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  cursor: pointer;
  font-size: 16px;
}
/* Reduce Hello username text only between 992px and 1080px */
@media (min-width: 992px) and (max-width: 1080px) {
  .user-name {
    font-size: 10px !important;
    max-width: 90px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
  }
}
/* Reduce Login/Signup text only between 992px and 1080px */
@media (min-width: 992px) and (max-width: 1080px) {
  .auth-header-btn span {
    font-size: 10px !important;
    font-weight: 500 !important;
  }
   /* Hide CALL button on mobile */
@media (max-width: 768px) {
  .contact-buttons .call-btn {
    display: none !important;
  }
}

/* Hide WhatsApp icon on mobile */
@media (max-width: 768px) {
  .contact-buttons .whatsapp-btn {
    display: none !important;
  }
}
 
}

      `}</style>
      {showAuthModal && (
  <AuthModal closeModal={() => setShowAuthModal(false)} />
)}
{showJourneyModal && (
  <MyJourneyModal
    email={user?.email}
    onClose={() => setShowJourneyModal(false)}
  />
)}

    </>
  );
};

export default Header;
